import React, { Component } from 'react';
import { auth } from '../../../../../Config/Firebase';
import firebase from 'firebase/app'
import firestore from 'firebase/firestore'
import './AddReferrals.css'
import { connect } from 'react-redux'
import { hideReferrals } from '../../../../../Actions/showReferralsAction'
import axios from 'axios'

let db = firebase.firestore();
let havenRef = db.collection("Users");

class AddReferrals extends Component {

    state = {
        name: '',
        email: '',
        phone: '',
        address: '',
        rep: '',
        
    }

     removeElementsByClass = (className) => {
        var elements = document.getElementsByClassName(className);
        while(elements.length > 0){
            elements[0].parentNode.removeChild(elements[0]);
        }
    }

submitReferral = (event) => {
        event.preventDefault()

        this.removeElementsByClass("referrals");
          
        auth.onAuthStateChanged((user) => {
            if (user) {
                let getName = this.state.name;
            
                let data ={
                    name: getName,
                    email: this.state.email,
                    phone: this.state.phone,
                    address: this.state.address,
                    rep: this.state.rep,
                    Job_Status: "Unverified",
                    Pay_Out: "No",
                    referrerFirst: this.props.firstName,
                    referrerLast: this.props.lastName,
                    referrerEmail: this.props.email,
                    referrerPhone: this.props.phone,
                    referrerUID: this.props.uid
                }

            havenRef.doc(user.uid).collection("Referrals").doc(getName).set(data).then(async() =>{
                
                document.getElementById("name").value = "";
                document.getElementById("email").value = "";
                document.getElementById("phone").value = "";
                document.getElementById("address").value = "";
                document.getElementById("salesRepName").value = "";
                this.setState({
                    name: '',
                    email: '',
                    phone: '',
                    address: '',
                    rep: ''
                })
                
                this.props.referralAdded();
                this.props.hideReferrals();
            
            });
            } else {
                console.log("NO USER");
            }   
            
        });   

    }

    hideReferralsForm = () => {
            document.getElementById("name").value = "";
            document.getElementById("email").value = "";
            document.getElementById("phone").value = "";
            document.getElementById("address").value = "";
            document.getElementById("salesRepName").value = "";

            this.props.hideReferrals();
    }
    

    render() { 
        return ( 
            <div>


           
                <div className={"jumbotron submit-box " + (this.props.showReferralsStatus ? "pos-top-show" : "pos-top-hide" ) }>
             
                <div className="row">
                    <div className="col-xl-12">
                    <button className="btn btn-primary closebutton" onClick={this.hideReferralsForm}>X</button>
                        <form className="referral_form"  onSubmit={(event) => { this.submitReferral(event)} }>
                            <span className ="miniHeadings" id="formHeading">Submit a Referral</span>
                            <ul>
                                <li><input className="addReferralInput" type="text" id="name" placeholder="First and Last Name..." required onChange={(event) => this.setState({ name: event.target.value})}/></li>
                                <li><input className="addReferralInput" type="email" id="email" placeholder="Email..." required onChange={(event) => this.setState({ email: event.target.value})}/></li>
                                <li><input className="addReferralInput" type="text" id="phone" placeholder="Phone Number" required onChange={(event) => this.setState({ phone: event.target.value})}/></li>
                                <li><input className="addReferralInput" type="text" id="address" placeholder="Address...(optional)" onChange={(event) => this.setState({address: event.target.value})}/></li>
                                <li><input className="addReferralInput" type="text" id="salesRepName" placeholder="Your Sales Rep's Name...(optional)" onChange={(event) => this.setState({rep: event.target.value})}/></li>
                                <li> <button type="submit" className="btn btn-primary referralsSubmitBtn">Submit</button></li>   
                            </ul>
                        </form>
                    </div>
                    </div>
                </div>
            </div>
           

         )
    }
}

const mapStateToProps = state => ({
    showReferralsStatus: state.showReferrals.showReferrals,
    firstName: state.firebase.firstName,
    lastName: state.firebase.lastName,
    email: state.firebase.email,
    phone: state.firebase.phonenumber,
    uid: state.firebase.uid,

})

const mapDispatchToProps = (dispatch) => {
    return {
    
        hideReferrals: () => dispatch(hideReferrals(""))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddReferrals);



// WEBPACK FOOTER //
// ./src/Components/Pages/MyHaven/HavenReferrals/AddReferrals/AddReferrals.jsx